import { Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { AnimationOnScroll } from 'react-animation-on-scroll';


export const Skills = () => {

    return (
        <Box className="no-overflow" sx={{ width: '100%', bgcolor: "#FDDF9E", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", p: { xs: "2rem",md:"5rem" ,lg: "5rem" }, textAlign: "center" }}>
            <Typography className="no-overflow" sx={{
                display: { xs: "flex", md:"flex" ,lg: 'flex' },
                fontFamily: 'Molin',
                fontSize: { xs: "0.9rem",md:"1.25rem" , lg: "1.25rem" },
                // fontWeight: 700,
                color: '#5A5A5A',
                textDecoration: 'none',
                textAlign: { xs: "center", md:"left" ,lg: "left" },
                m: "auto",
                mb: "1.5rem",
                width: { xs: "100%", md:"50%" ,lg: "50%" },
                alignItems: { xs: "center",md:"normal" , lg: "normal" }
            }} >Want to know where I can
                <Typography className="no-overflow" sx={{
                    isplay: { xs: "flex",md:"flex" , lg: 'flex' },
                    fontFamily: 'Molin',
                    fontSize: { xs: "0.75rem", md:"1.25rem" ,lg: "1.25rem" },
                    // fontWeight: 700,
                    color: 'inherit',
                    textDecoration: 'none',
                    textAlign: { xs: "center",md:"left" , lg: "left" },
                    alignItems: { xs: "center",md:"normal" , lg: "normal" },
                }} >&nbsp;</Typography>
                <Typography className="no-overflow" sx={{
                    display: { xs: "flex", md:"flex" ,lg: 'flex' },
                    fontFamily: 'Molin',
                    fontSize: { xs: "1rem",md:"1.25rem" , lg: "1.25rem" },
                    // fontWeight: 700,
                    color: '#000000',
                    textDecoration: 'none',
                    textAlign: { xs: "center",md:"left" , lg: "left" },
                    alignItems: { xs: "center",md:"normal" , lg: "normal" },
                }} >Help?</Typography>
            </Typography>
            <Box className="no-overflow" sx={{ width: {xs:"100%",md:"50%",lg:'50%'}, textAlign: "center" }}>
                <Grid className="no-overflow" container spacing={2} columnSpacing={{ xs: 1, md: 2, lg: 3 }} rowSpacing={5} maxHeight="75vh" minHeight="25vh" color="white" m="auto">
                    <Grid className="no-overflow" item xs={6} textAlign="left" width="100%" sx={{mt:{xs:"0",md:"1rem",lg:"1rem"}}} >
                        <AnimationOnScroll animateIn="animate__bounceInDown" animateOnce="true">
                            <Typography className="no-overflow" sx={{
                                display: { xs: "flex", md:"flex", lg: 'flex' },
                                fontFamily: 'Title',
                                letterSpacing: '.1rem',
                                fontSize: { xs: "1rem",md:"1.3rem", lg: "1.5rem" },
                                fontWeight: 600,
                                color: '#353535',
                                textDecoration: 'none',
                                textAlign: { xs: "left",md:"left", lg: "left" },
                                mb: {xs:"0.5rem",md:"1rem",lg:"1.5rem"}
                            }} >Web Development</Typography>
                        </AnimationOnScroll>
                        <AnimationOnScroll animateIn="animate__bounceInLeft" animateOnce="true">
                            <Typography className="no-overflow" sx={{
                                display: { xs: "flex",md:"flex", lg: 'flex' },
                                fontFamily: 'Molin',
                                fontSize: { xs: "0.75rem", md:"0.9rem",lg: "1rem" },
                                // fontWeight: 700,
                                color: '#464646',
                                textDecoration: 'none',
                                textAlign: { xs: "left",md:"left", lg: "left" },
                                mb: {xs:"0.5rem",md:"1rem",lg:"1.5rem"}
                            }} >Building Websites using the MERN Stack! <br />
                                Experience Level: Beginner</Typography>
                        </AnimationOnScroll>

                    </Grid>
                    <Grid className="no-overflow" item xs={6} textAlign="left" width="100%"  sx={{mt:{xs:"0",md:"1rem",lg:"1rem"}}} >
                        <AnimationOnScroll animateIn="animate__bounceInDown" animateOnce="true">
                            <Typography className="no-overflow" sx={{
                               display: { xs: "flex", md:"flex", lg: 'flex' },
                               fontFamily: 'Title',
                               letterSpacing: '.1rem',
                               fontSize: { xs: "1rem",md:"1.3rem", lg: "1.5rem" },
                               fontWeight: 600,
                               color: '#353535',
                               textDecoration: 'none',
                               textAlign: { xs: "left",md:"left", lg: "left" },
                               mb: {xs:"0.5rem",md:"1rem",lg:"1.5rem"}
                            }} >Game Development</Typography>
                        </AnimationOnScroll>
                        <AnimationOnScroll animateIn="animate__bounceInRight" animateOnce="true">
                            <Typography className="no-overflow" sx={{
                                display: { xs: "flex",md:"flex", lg: 'flex' },
                                fontFamily: 'Molin',
                                fontSize: { xs: "0.75rem", md:"0.9rem",lg: "1rem" },
                                // fontWeight: 700,
                                color: '#464646',
                                textDecoration: 'none',
                                textAlign: { xs: "left",md:"left", lg: "left" },
                                mb: {xs:"0.5rem",md:"1rem",lg:"1.5rem"}
                            }} >I can make Games using the Unity Game Engine. Preferred Genre would be 2D Games. <br />Experience Level: Intermediate</Typography>
                        </AnimationOnScroll>

                    </Grid>
                    <Grid className="no-overflow" item xs={6} textAlign="left" width="100%" sx={{mt:{xs:"0",lg:"1rem"}}}>
                        <AnimationOnScroll animateIn="animate__bounceInUp" animateOnce="true">
                            <Typography className="no-overflow" sx={{
                                display: { xs: "flex", md:"flex", lg: 'flex' },
                                fontFamily: 'Title',
                                letterSpacing: '.1rem',
                                fontSize: { xs: "1rem",md:"1.3rem", lg: "1.5rem" },
                                fontWeight: 600,
                                color: '#353535',
                                textDecoration: 'none',
                                textAlign: { xs: "left",md:"left", lg: "left" },
                                mb: {xs:"0.5rem",md:"1rem",lg:"1.5rem"}
                            }} >Machine Learning</Typography>
                        </AnimationOnScroll>
                        <AnimationOnScroll animateIn="animate__bounceInLeft" animateOnce="true">
                            <Typography className="no-overflow" sx={{
                               display: { xs: "flex",md:"flex", lg: 'flex' },
                               fontFamily: 'Molin',
                               fontSize: { xs: "0.75rem", md:"0.9rem",lg: "1rem" },
                               // fontWeight: 700,
                               color: '#464646',
                               textDecoration: 'none',
                               textAlign: { xs: "left",md:"left", lg: "left" },
                               mb: {xs:"0.5rem",md:"1rem",lg:"1.5rem"}
                            }} >I know basic algorithms and their use-cases and can learn and apply aditional knowledge as and when required.<br />Experience Level: Beginner</Typography>
                        </AnimationOnScroll>
                    </Grid>
                    {/* <Grid className="no-overflow" item xs={6} textAlign="left" width="100%" sx={{mt:{xs:"0",lg:"1rem"}}}>
                        <AnimationOnScroll animateIn="animate__bounceInUp" animateOnce="true">
                            <Typography className="no-overflow" sx={{
                                display: { xs: "flex", lg: 'flex' },
                                fontFamily: 'Title',
                                letterSpacing: '.1rem',
                                fontSize: { xs: "1rem", lg: "1.5rem" },
                                fontWeight: 600,
                                color: '#353535',
                                textDecoration: 'none',
                                textAlign: { xs: "left", lg: "left" },
                                mb: {xs:"0.5rem",lg:"1.5rem"}
                            }} align="right">Website Development</Typography>
                        </AnimationOnScroll>
                        <AnimationOnScroll animateIn="animate__bounceInRight" animateOnce="true">
                            <Typography sx={{
                                display: { xs: "flex", lg: 'flex' },
                                fontFamily: 'Molin',
                                fontSize: { xs: "0.75rem", lg: "1rem" },
                                // fontWeight: 700,
                                color: '#464646',
                                textDecoration: 'none',
                                textAlign: { xs: "left", lg: "left" },
                                mb: {xs:"0.5rem",lg:"1.5rem"}
                            }} >Lorem Ipsum Lorem Ipsum
                                Lorem Ipsum Lorem Ipsum
                                Lorem Ipsum</Typography>
                        </AnimationOnScroll>
                    </Grid> */}
                </Grid>
            </Box>
        </Box >
    );
}